/**
 * ``auth.*`` event schemas — frontend-emitted variants only.
 *
 * Backend-emitted auth events (``auth.session.started``,
 * ``auth.login.failed``, ``auth.session.ended``, ``auth.mfa.enrolled``,
 * ``auth.password.reset_completed``, ``auth.password.changed``,
 * ``auth.invite.accepted``) have their own Pydantic models on the
 * backend (PR-5+) and must not be added here — the frontend never
 * captures them.
 *
 * Source of truth: ``plans/PLAN_POSTHOG_02_EVENT_CATALOG.md`` §
 * "auth.*", "Source" column = "frontend".
 */

import { z } from "zod";

import { BaseEventSchema } from "./base";
import { LoginMethodProperty } from "./properties";

export const AuthLoginViewedSchema = BaseEventSchema.extend({
  event_name: z.literal("auth.login.viewed"),
  screen: z.string(),
});

export const AuthLoginSubmittedSchema = BaseEventSchema.extend({
  event_name: z.literal("auth.login.submitted"),
  screen: z.string(),
  method: LoginMethodProperty,
});

export const AuthMfaViewedSchema = BaseEventSchema.extend({
  event_name: z.literal("auth.mfa.viewed"),
  screen: z.string(),
});

export const AuthPasswordResetRequestedSchema = BaseEventSchema.extend({
  event_name: z.literal("auth.password.reset_requested"),
});

export const AuthInviteViewedSchema = BaseEventSchema.extend({
  event_name: z.literal("auth.invite.viewed"),
  screen: z.string(),
});

export const AuthInviteExpiredSchema = BaseEventSchema.extend({
  event_name: z.literal("auth.invite.expired"),
});

export const authEvents = [
  AuthLoginViewedSchema,
  AuthLoginSubmittedSchema,
  AuthMfaViewedSchema,
  AuthPasswordResetRequestedSchema,
  AuthInviteViewedSchema,
  AuthInviteExpiredSchema,
] as const;
